import React from 'react';

import { useDispatch, useSelector } from "react-redux";

const PreloaderCategory = () => {

    const theme = useSelector((state) => state.initData.theme);

    return (
        <>
            {theme == 'dark' && (
                <svg width="375" height="941" viewBox="0 0 375 941" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1_2903)">
                    <g filter="url(#filter0_b_1_2903)">
                    <rect x="16" y="12" width="226" height="24" rx="12" fill="#333333"/>
                    </g>
                    <g filter="url(#filter1_b_1_2903)">
                    <rect x="306" y="12" width="53" height="24" rx="12" fill="#333333"/>
                    </g>
                    <g filter="url(#filter2_b_1_2903)">
                    <rect x="16" y="52" width="253" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter3_b_1_2903)">
                    <rect x="277" y="52" width="253" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter4_b_1_2903)">
                    <rect x="16" y="232" width="199" height="24" rx="12" fill="#333333"/>
                    </g>
                    <g filter="url(#filter5_b_1_2903)">
                    <rect x="16" y="272" width="167.5" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter6_b_1_2903)">
                    <rect x="16" y="436" width="107" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter7_b_1_2903)">
                    <rect x="16" y="456" width="167.5" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter8_b_1_2903)">
                    <rect x="191.5" y="272" width="167.5" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter9_b_1_2903)">
                    <rect x="191.5" y="436" width="107" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter10_b_1_2903)">
                    <rect x="191.5" y="456" width="167.5" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter11_b_1_2903)">
                    <rect x="16" y="504" width="167.5" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter12_b_1_2903)">
                    <rect x="16" y="668" width="107" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter13_b_1_2903)">
                    <rect x="16" y="688" width="167.5" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter14_b_1_2903)">
                    <rect x="191.5" y="504" width="167.5" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter15_b_1_2903)">
                    <rect x="191.5" y="668" width="107" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter16_b_1_2903)">
                    <rect x="191.5" y="688" width="167.5" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter17_b_1_2903)">
                    <rect x="16" y="736" width="167.5" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter18_b_1_2903)">
                    <rect x="16" y="900" width="107" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter19_b_1_2903)">
                    <rect x="16" y="920" width="167.5" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter20_b_1_2903)">
                    <rect x="191.5" y="736" width="167.5" height="152" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter21_b_1_2903)">
                    <rect x="191.5" y="900" width="107" height="16" rx="8" fill="#333333"/>
                    </g>
                    <g filter="url(#filter22_b_1_2903)">
                    <rect x="191.5" y="920" width="167.5" height="16" rx="8" fill="#333333"/>
                    </g>
                    </g>
                    <defs>
                    <filter id="filter0_b_1_2903" x="-24" y="-28" width="306" height="104" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter1_b_1_2903" x="266" y="-28" width="133" height="104" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter2_b_1_2903" x="-24" y="12" width="333" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter3_b_1_2903" x="237" y="12" width="333" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter4_b_1_2903" x="-24" y="192" width="279" height="104" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter5_b_1_2903" x="-24" y="232" width="247.5" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter6_b_1_2903" x="-24" y="396" width="187" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter7_b_1_2903" x="-24" y="416" width="247.5" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter8_b_1_2903" x="151.5" y="232" width="247.5" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter9_b_1_2903" x="151.5" y="396" width="187" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter10_b_1_2903" x="151.5" y="416" width="247.5" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter11_b_1_2903" x="-24" y="464" width="247.5" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter12_b_1_2903" x="-24" y="628" width="187" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter13_b_1_2903" x="-24" y="648" width="247.5" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter14_b_1_2903" x="151.5" y="464" width="247.5" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter15_b_1_2903" x="151.5" y="628" width="187" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter16_b_1_2903" x="151.5" y="648" width="247.5" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter17_b_1_2903" x="-24" y="696" width="247.5" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter18_b_1_2903" x="-24" y="860" width="187" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter19_b_1_2903" x="-24" y="880" width="247.5" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter20_b_1_2903" x="151.5" y="696" width="247.5" height="232" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter21_b_1_2903" x="151.5" y="860" width="187" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <filter id="filter22_b_1_2903" x="151.5" y="880" width="247.5" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="20"/>
                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1_2903"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1_2903" result="shape"/>
                    </filter>
                    <clipPath id="clip0_1_2903">
                    <rect width="375" height="941" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>                
            ) || (
                <svg
                    width="375"
                    height="941"
                    viewBox="0 0 375 941"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_1_2903)">
                        <g filter="url(#filter0_b_1_2903)">
                            <rect
                                x="16"
                                y="12"
                                width="226"
                                height="24"
                                rx="12"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter1_b_1_2903)">
                            <rect
                                x="306"
                                y="12"
                                width="53"
                                height="24"
                                rx="12"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter2_b_1_2903)">
                            <rect
                                x="16"
                                y="52"
                                width="253"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter3_b_1_2903)">
                            <rect
                                x="277"
                                y="52"
                                width="253"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter4_b_1_2903)">
                            <rect
                                x="16"
                                y="232"
                                width="199"
                                height="24"
                                rx="12"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter5_b_1_2903)">
                            <rect
                                x="16"
                                y="272"
                                width="167.5"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter6_b_1_2903)">
                            <rect
                                x="16"
                                y="436"
                                width="107"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter7_b_1_2903)">
                            <rect
                                x="16"
                                y="456"
                                width="167.5"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter8_b_1_2903)">
                            <rect
                                x="191.5"
                                y="272"
                                width="167.5"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter9_b_1_2903)">
                            <rect
                                x="191.5"
                                y="436"
                                width="107"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter10_b_1_2903)">
                            <rect
                                x="191.5"
                                y="456"
                                width="167.5"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter11_b_1_2903)">
                            <rect
                                x="16"
                                y="504"
                                width="167.5"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter12_b_1_2903)">
                            <rect
                                x="16"
                                y="668"
                                width="107"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter13_b_1_2903)">
                            <rect
                                x="16"
                                y="688"
                                width="167.5"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter14_b_1_2903)">
                            <rect
                                x="191.5"
                                y="504"
                                width="167.5"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter15_b_1_2903)">
                            <rect
                                x="191.5"
                                y="668"
                                width="107"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter16_b_1_2903)">
                            <rect
                                x="191.5"
                                y="688"
                                width="167.5"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter17_b_1_2903)">
                            <rect
                                x="16"
                                y="736"
                                width="167.5"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter18_b_1_2903)">
                            <rect
                                x="16"
                                y="900"
                                width="107"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter19_b_1_2903)">
                            <rect
                                x="16"
                                y="920"
                                width="167.5"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter20_b_1_2903)">
                            <rect
                                x="191.5"
                                y="736"
                                width="167.5"
                                height="152"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter21_b_1_2903)">
                            <rect
                                x="191.5"
                                y="900"
                                width="107"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                        <g filter="url(#filter22_b_1_2903)">
                            <rect
                                x="191.5"
                                y="920"
                                width="167.5"
                                height="16"
                                rx="8"
                                fill="#E9E9EB"
                            />
                        </g>
                    </g>
                    <defs>
                        <filter
                            id="filter0_b_1_2903"
                            x="-24"
                            y="-28"
                            width="306"
                            height="104"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter1_b_1_2903"
                            x="266"
                            y="-28"
                            width="133"
                            height="104"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter2_b_1_2903"
                            x="-24"
                            y="12"
                            width="333"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter3_b_1_2903"
                            x="237"
                            y="12"
                            width="333"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter4_b_1_2903"
                            x="-24"
                            y="192"
                            width="279"
                            height="104"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter5_b_1_2903"
                            x="-24"
                            y="232"
                            width="247.5"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter6_b_1_2903"
                            x="-24"
                            y="396"
                            width="187"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter7_b_1_2903"
                            x="-24"
                            y="416"
                            width="247.5"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter8_b_1_2903"
                            x="151.5"
                            y="232"
                            width="247.5"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter9_b_1_2903"
                            x="151.5"
                            y="396"
                            width="187"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter10_b_1_2903"
                            x="151.5"
                            y="416"
                            width="247.5"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter11_b_1_2903"
                            x="-24"
                            y="464"
                            width="247.5"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter12_b_1_2903"
                            x="-24"
                            y="628"
                            width="187"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter13_b_1_2903"
                            x="-24"
                            y="648"
                            width="247.5"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter14_b_1_2903"
                            x="151.5"
                            y="464"
                            width="247.5"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter15_b_1_2903"
                            x="151.5"
                            y="628"
                            width="187"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter16_b_1_2903"
                            x="151.5"
                            y="648"
                            width="247.5"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter17_b_1_2903"
                            x="-24"
                            y="696"
                            width="247.5"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter18_b_1_2903"
                            x="-24"
                            y="860"
                            width="187"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter19_b_1_2903"
                            x="-24"
                            y="880"
                            width="247.5"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter20_b_1_2903"
                            x="151.5"
                            y="696"
                            width="247.5"
                            height="232"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter21_b_1_2903"
                            x="151.5"
                            y="860"
                            width="187"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <filter
                            id="filter22_b_1_2903"
                            x="151.5"
                            y="880"
                            width="247.5"
                            height="96"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feGaussianBlur in="BackgroundImageFix" stdDeviation="20" />
                            <feComposite
                                in2="SourceAlpha"
                                operator="in"
                                result="effect1_backgroundBlur_1_2903"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_backgroundBlur_1_2903"
                                result="shape"
                            />
                        </filter>
                        <clipPath id="clip0_1_2903">
                            <rect width="375" height="941" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            )}
        </>
    );
};

export default PreloaderCategory;
